(function(config) {
    'use strict';

    angular.module('product.services', [
            'ngResource'
        ])
        .factory('categoryDataSrvc', categoryDataSrvc)
        .factory('categorySrvc', categorySrvc)
        .factory('productDataSrvc', productDataSrvc)
        .factory('productSrvc', productSrvc)
        .factory('packageDataSrvc', packageDataSrvc)
        .factory('packageSrvc', packageSrvc)
        .factory('inpostLockerLimitDataSrvc', inpostLockerLimitDataSrvc)
        .factory('productParameterDataSrvc', productParameterDataSrvc)
        .factory('productParameterSrvc', productParameterSrvc)
        .factory('productParameterOptionDataSrvc', productParameterOptionDataSrvc)
        .factory('productQuantityDataSrvc', productQuantityDataSrvc)
        .factory('productQuantitySrvc', productQuantitySrvc)
        .factory('productOptionGroupDataSrvc', productOptionGroupDataSrvc)
        .factory('productOptionGroupSrvc', productOptionGroupSrvc)
        .factory('productOptionDataSrvc', productOptionDataSrvc)
        .factory('productOptionSrvc', productOptionSrvc)
        .factory('productOptionTechLineDataSrvc', productOptionTechLineDataSrvc)
        .factory('productOptionPricesDataSrvc', productOptionPricesDataSrvc)
        .factory('productOptionExclusionDataSrvc', productOptionExclusionDataSrvc)
        .factory('productOptionExclusionSrvc', productOptionExclusionSrvc)
        .factory('productGalleryDataSrvc', productGalleryDataSrvc)
        .factory('discountDataSrvc', discountDataSrvc)
        .factory('discountModalSrvc', discountModalSrvc);

    categoryDataSrvc.$inject = ['$resource',  'transformRequestSrvc'];

    function categoryDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/categories/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            categoryParents: {
                url: config.api + '/api/v1/categories/admin_category_parents/',
                isArray: true,
                method: 'GET'
            },
            productParents: {
                url: config.api + '/api/v1/categories/admin_product_parents/',
                isArray: true,
                method: 'GET'
            },
            productFilter: {
                url: config.api + '/api/v1/categories/admin_product_filter/',
                isArray: true,
                method: 'GET'
            },
        });
    }

    categorySrvc.$inject = ['categoryDataSrvc', 'modalSrvc'];

    function categorySrvc(categoryDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    categoryDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productDataSrvc.$inject = ['$resource', 'transformRequestSrvc', 'transformResponseSrvc'];

    function productDataSrvc($resource, transformRequestSrvc, transformResponseSrvc) {
        return $resource(config.api + '/api/v1/products/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            kindOptions: {
                method: 'GET',
                url: config.api + '/api/v1/products/admin_kind_options/',
                isArray: true
            },
            copy: {
                method: 'POST',
                url: config.api + '/api/v1/products/:pk/copy_product/',
                params: {
                    pk: '@pk'
                }
            },
            exportPrices: {
                method: 'GET',
                url: config.api + '/api/v1/products/:pk/export_product_prices/',
                params: {
                    pk: '@pk'
                },
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.excelArrayBufferTransform
            },
            importPrices: {
                method: 'POST',
                url: config.api + '/api/v1/products/:pk/import_product_prices/',
                params: {
                    pk: '@pk'
                },
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            getQuantities: {
                method: 'GET',
                url: config.api + '/api/v1/products/:pk/admin_quantities/',
                params: {
                    pk: '@pk'
                },
                isArray: true
            },
            getProductGroupOptions: {
                method: 'GET',
                url: config.api + '/api/v1/products/:pk/admin_group_options/',
                params: {
                    pk: '@pk'
                },
                isArray: true
            },
            getProductPricing: {
                method: 'GET',
                url: config.api + '/api/v1/products/:pk/admin_pricing/',
                params: {
                    pk: '@pk'
                },
                isArray: false
            },
            getProductWeight: {
                method: 'GET',
                url: config.api + '/api/v1/products/:pk/admin_weight/',
                params: {
                    pk: '@pk'
                },
                isArray: false
            },
            getProductDescriptionForOffer: {
                method: 'GET',
                url: config.api + '/api/v1/products/:pk/admin_description_for_offer/',
                params: {
                    pk: '@pk'
                },
                isArray: false
            },
            optionsList: {
                method: 'GET',
                url: config.api + '/api/v1/products/admin_options_list/',
                isArray: false
            },
            allegroOptionsList: {
                method: 'GET',
                url: config.api + '/api/v1/products/admin_allegro_options_list/',
            },
            applyProductLog: {
                method: 'POST',
                url: config.api + '/api/v1/products/:pk/admin_apply_product_log/',
                params: {
                    pk: '@pk'
                },
                isArray: true
            },
            applyManyProductLog: {
                method: 'POST',
                url: config.api + '/api/v1/products/admin_apply_many_product_log/',
                isArray: true
            },
            publishMany: {
                method: 'POST',
                url: config.api + '/api/v1/products/admin_publish_many/',
                isArray: true
            }
        });
    }

    productSrvc.$inject = ['productDataSrvc', 'modalSrvc', 'downloadLinkSrvc'];

    function productSrvc(productDataSrvc, modalSrvc, downloadLinkSrvc) {

        return {
            remove: remove,
            exportProductPrices: exportProductPrices,
            isMultipleGroupOption: isMultipleGroupOption,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    productDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }

        function exportProductPrices(productId) {
            return productDataSrvc.exportPrices({
                pk: productId
            }).$promise.then(
                function(response) {
                    downloadLinkSrvc.saveFile(response);
                    return response;
                }
            );
        }

        function isMultipleGroupOption(group) {
            return group.is_multiple;
        }
    }

    packageDataSrvc.$inject = ['$resource'];

    function packageDataSrvc($resource) {
        return $resource(config.api + '/api/v1/packages/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            packageOptions: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/packages/admin_package_options/'
            }
        });
    }

    inpostLockerLimitDataSrvc.$inject = ['$resource'];

    function inpostLockerLimitDataSrvc($resource) {
        // a single record per site, no pk in the url
        return $resource(config.api + '/api/v1/inpost-locker-limits/current/', {}, {
            get: {
                method: 'GET'
            },
            update: {
                method: 'PATCH'
            }
        });
    }

    packageSrvc.$inject = ['packageDataSrvc', 'modalSrvc'];

    function packageSrvc(packageDataSrvc, modalSrvc) {
        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    packageDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productParameterDataSrvc.$inject = ['$resource'];

    function productParameterDataSrvc($resource) {
        return $resource(config.api + '/api/v1/product-parameters/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/product-parameters/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            productParameters: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-parameters/admin_product_parameters/'
            }
        });
    }

    productParameterSrvc.$inject = ['productParameterDataSrvc', 'modalSrvc'];

    function productParameterSrvc(productParameterDataSrvc, modalSrvc) {
        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    productParameterDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productParameterOptionDataSrvc.$inject = ['$resource'];

    function productParameterOptionDataSrvc($resource) {
        return $resource(config.api + '/api/v1/product-parameter-options/:pk/', { pk: '@pk' }, {
            update: {
                method: 'PATCH'
            }
        });
    }

    productQuantityDataSrvc.$inject = ['$resource'];

    function productQuantityDataSrvc($resource) {
        return $resource(config.api + '/api/v1/quantities/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            montageProductFilterQuantity: {
                method: 'GET',
                url: config.api + '/api/v1/quantities/admin_montage_product_filter_quantity/',
                isArray: true
            }
        });
    }

    productQuantitySrvc.$inject = ['productQuantityDataSrvc', 'modalSrvc'];

    function productQuantitySrvc(productQuantityDataSrvc, modalSrvc) {
        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    productQuantityDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productOptionGroupDataSrvc.$inject = ['$resource', 'transformRequestSrvc', 'transformResponseSrvc'];

    function productOptionGroupDataSrvc($resource, transformRequestSrvc, transformResponseSrvc) {
        return $resource(config.api + '/api/v1/product-group-options/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/product-group-options/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            groupChoiceChoices: {
                url: config.api + '/api/v1/product-group-options/group_choices/',
                isArray: true,
                method: 'GET'
            },
            productGroupOptions: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-group-options/admin_product_group_options/'
            },
            montageProductFilterOptionsGroup: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-group-options/admin_montage_product_filter_group_options/'
            },
            productionCubeProductFilterOptionsGroup: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-group-options/admin_production_cube_product_filter_group_options/'
            },
            optionsExport: {
                method: 'GET',
                url: config.api + '/api/v1/product-group-options/admin_groups_options_export/',
                responseType: 'arraybuffer',
                transformResponse: transformResponseSrvc.csvArrayBufferTransform
            }
        });
    }

    productOptionGroupSrvc.$inject = ['productOptionGroupDataSrvc', 'modalSrvc'];

    function productOptionGroupSrvc(productOptionGroupDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    productOptionGroupDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productOptionDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function productOptionDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/product-options/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page',
                    options_group: '@options_group',
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            optionsList: {
                method: 'GET',
                url: config.api + '/api/v1/product-options/admin_options_list/',
            },
            forProcessStage: {
                method: 'GET',
                url: config.api + '/api/v1/product-options/admin_for_process_stage/',
                params: {
                    paginated: true
                }
            },
            productOptions: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-options/admin_product_options/'
            },
            montagePaperOptions: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-options/admin_montage_paper_options/'
            },
            montageProductFilterPaper: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-options/admin_montage_product_filter_paper_options/'
            },
            adminKindOptions: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/product-options/admin_kind_options/'
            },
            optionsSearchList: {
                method: 'GET',
                isArray: false,
                url: config.api + '/api/v1/product-options/admin_search_list/'
            }
        });
    }

    productOptionSrvc.$inject = ['productOptionDataSrvc', 'modalSrvc'];

    function productOptionSrvc(productOptionDataSrvc, modalSrvc) {

        return {
            remove: remove
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    productOptionDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productOptionTechLineDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function productOptionTechLineDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/product-option-tech-line/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            }
        });
    }

    productOptionPricesDataSrvc.$inject = ['$resource'];

    function productOptionPricesDataSrvc($resource) {
        return $resource('', {}, {
            priceDetail: {
                method: 'PUT',
                isArray: true,
                url: config.api + '/api/v1/product-option-prices/price_detail/'
            }
        });
    }

    productOptionExclusionSrvc.$inject = ['productOptionExclusionDataSrvc', 'modalSrvc'];

    function productOptionExclusionSrvc(productOptionExclusionDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    productOptionExclusionDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    productOptionExclusionDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function productOptionExclusionDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/product-options-exclusion/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                },
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    productGalleryDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function productGalleryDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/product-gallery/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                },
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    discountDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function discountDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/discounts/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                isArray: true
            },
            update: {
                method: 'PATCH'
            },
            createDiscountForQuantity: {
                method: 'POST',
                url: config.api + '/api/v1/discounts/create_discount_for_quantity/'
            },
            updateDiscountsForQuantity: {
                method: 'POST',
                url: config.api + '/api/v1/discounts/update_discounts_for_quantity/',
                isArray: true
            },
            importDiscountsForQuantity: {
                method: 'POST',
                url: config.api + '/api/v1/discounts/import_discounts_for_quantity/',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            deleteDiscountForQuantities: {
                method: 'DELETE',
                url: config.api + '/api/v1/discounts/delete_discount_for_quantities/'
            }
        });
    }

    discountModalSrvc.$inject = ['$uibModal'];

    function discountModalSrvc($uibModal) {
        return {
            updateModal: updateModal
        };

        function updateModal(dataObj, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/product/views/discounts-update/discounts-update-modal.html',
                controller: 'DiscountsUpdateModalController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'discount-modal',
                resolve: {
                    dataObj: function () {
                        return dataObj;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
    }
})(window.config);
